<template>
    <!-- Error page-->
    <div class="misc-wrapper">
      <b-link class="brand-logo">
        <!--      <vuexy-logo />-->
  
        <h2 class="brand-text text-primary ml-1">
          Lobitozz
        </h2>
      </b-link>
  
      <div class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
          <h3 class="mb-1">
            Archivos cargados con éxito. Validaremos la documentación y, si es necesario, solicitaremos información adicional.          </h3>
          <b-img
            :src="appLogoLobitozz"
            alt="logo"
          />
          <h2><br> <b>Gracias por su confianza.</b> </h2>
        </div>
      </div>
    </div>
  <!-- / Error page-->
  </template>
  
  <script>
  /* eslint-disable global-require */
  import { BLink, BButton, BImg } from 'bootstrap-vue'
  import VuexyLogo from '@core/layouts/components/Logo.vue'
  import store from '@/store/index'
  import { $themeConfig } from '@themeConfig'
  
  export default {
    setup() {
      const { appName, appLogoImage, appLogoLobitozz } = $themeConfig.app
      return {
        appName,
        appLogoImage,
        appLogoLobitozz,
      }
    },
    components: {
      VuexyLogo,
      BLink,
      BButton,
      BImg,
    },
    data() {
      return {
        downImg: require('@/assets/images/pages/error.svg'),
      }
    },
    computed: {
      imgUrl() {
        if (store.state.appConfig.layout.skin === 'dark') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.downImg = require('@/assets/images/pages/error-dark.svg')
          return this.downImg
        }
        return this.downImg
      },
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/pages/page-misc.scss';
  </style>
  